<script lang="ts">
  export let addContentClass: boolean = false;
</script>

<div class="blog-card">
  <div class={addContentClass ? 'blog-content' : 'content-fullwidth'}>
    <slot></slot>
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .blog-content {
    max-width: 1440px;
    margin-inline: auto;
    padding: 0 24px;
    &.content-fullwidth {
      max-width: 100%;
    }
    @include desktop-max-width {
      padding: 0 16px;
    }
  }
</style>
